module.exports = __webpack_public_path__ + "static/media/logo_ministere_education.c3ff56ed.svg";